import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';

import { AdminSettingComponent } from '../setting.component';
import { SwalErrorHandler, SwalResponseHandler, WIDGET_SETTING_CODE, SWAL_COMMMON } from '../../../../shared/constants';

declare const swal: any;

@Component({
  selector: 'drx-setting-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.scss']
})
export class AdminSettingEmailComponent extends AdminSettingComponent implements OnInit {

  public title = 'Setting - Email';
  public path = 'admin/setting/email';

  public ngOnInit(): void {
    super.ngOnInit();
    this.loadItem();
    this.createForm();
  }

  public loadItem() {
    this.apiService.findById(WIDGET_SETTING_CODE)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(res => {
        this.bindData(res.data);
        this.form.patchValue(this.item);
      }, error => {
        swal(SwalErrorHandler.errorMessage(error));
      });
  }

  public createForm() {
    this.form = this.formBuilder.group({
      title: ['', Validators.required],
      body: ['', Validators.required],
      document: ['', Validators.required],
    });
  }

  public bindData(data: any) {
    this.item = data.value;
  }

  public onSave() {
    this.apiService.patchAttributes(WIDGET_SETTING_CODE, {
      value: this.form.value
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe(res => {
      swal(SWAL_COMMMON.UPDATE_SUCCESS);
    });
  }

  public uploadedImage(event) {
    this.item['document'] = event;
    if (this.form.controls['document']) {
      this.form.controls['document'].setValue(event);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/setting/email/email.component.ts